import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';

var _excluded = ["duration"];
var Progress = function Progress(_ref) {
  var _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? undefined : _ref$duration,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var style;

  if (duration) {
    style = {
      animationDuration: duration + "ms"
    };
  }

  var className = cn('yt-progress', {
    'yt-progress--indeterminate': !duration
  }, props.className);
  return React__default.createElement("span", Object.assign({}, props, {
    className: className
  }), React__default.createElement("span", {
    className: "yt-progress__bar",
    style: style
  }));
};

export { Progress };
//# sourceMappingURL=Progress.js.map
